import beersManagerSaga from 'features/beersManager/saga';
import {postSaga} from 'features/postGenerator/saga';
import {beerStylePreviewSaga} from 'pages/beerStylesView/store/saga';
import {beersPreviewSaga} from 'pages/beersView/store/saga';
import {postArchiveSaga} from 'pages/postArchive/store/saga';
import {SinglePubSaga} from 'pages/pubPagesView/store/saga';
import {all} from 'redux-saga/effects';

import appSaga from './app/saga';
import beersSaga from './beers/saga';
import beerStylesSaga from './beerStyles/saga';
import breweriesSaga from './breweries/saga';
import managedPubSaga from './managedPub/saga';
import {pageEditorsSaga} from './pageEditors/saga';
import {postsSaga} from './posts/saga';
import profileSaga from './profile/saga';
import pubsSaga from './pubs/saga';
import singleBrewerySaga from './singleBrewery/saga';
import {singlePageEditorSaga} from './singlePageEditor/saga';

export default function* rootSaga() {
  yield all([
    appSaga(),
    profileSaga(),
    beerStylesSaga(),
    beersSaga(),
    breweriesSaga(),
    singleBrewerySaga(),
    pubsSaga(),
    pageEditorsSaga(),
    managedPubSaga(),
    beersManagerSaga(),
    postSaga(),
    postsSaga(),
    postArchiveSaga(),
    // Preview Saga's
    SinglePubSaga(),
    singlePageEditorSaga(),
    beersPreviewSaga(),
    beerStylePreviewSaga(),
  ]);
}
